import PropTypes from 'prop-types';
/**
 * Vytvoří položky hodnot pro [SelectField](/#/Components/Fields/SelectField).
 */

function SelectFieldItem()
/* props */
{
  // eslint-disable-line react/prefer-stateless-function
  return null;
}

SelectFieldItem.propTypes = {
  /**
   * String nebo Node reprezentujici zobrazeni hodnoty vyberu.
   */
  children: PropTypes.node,
  selected: PropTypes.bool,

  /**
   * Hodnota polozky.
   * Pokud bude `undefined` nebo `null`, polozku nebude mozne vybrat.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
};
SelectFieldItem.defaultProps = {
  children: null,
  selected: false,
  value: undefined
};
export default SelectFieldItem;